<template>
  <v-row>
    <div class="col-md-12 home-box">
      <Breadcrumbs :title="'Taxes'" />
      <TaxList />
    </div>
    <div class="col-md-12 home-tabs-body">
      
    </div>
  </v-row>
</template>

<script>
import TaxList from "@/components/taxes/TaxList.vue";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";

export default {
  name: "Taxes",
  components: {
    TaxList,
    Breadcrumbs,
  },
};
</script>
